export enum Stage {
  LeadDetails = "lead-details",
  Success = "success"
}

export enum Form {
  LeadDetails = "leadDetails",
  LeadDetailsModalJourney = "leadDetailsModalJourney"
}

export const FETCH_LEAD_QUERY_KEY = "current-user-tutoring-lead";
